import { AuthModel } from './auth.model';

export class UserModel extends AuthModel {
	uuid!: string;
	userId!: string;
	username!: string;
	password!: string;
	name!: string;
	email!: string;
	pic!: string;
	role!: {};
	occupation!: string;
	inviteAccepted!: boolean;
	phone!: string;
	address?: {};
	socialNetworks?: {};
	firstname!: string;
	lastname!: string;
	website!: string;
	language!: string;
	timeZone!: string;
	communication!: {
		email: boolean;
		sms: boolean;
		phone: boolean;
	};
	emailSettings!: {};

	setUser(user: any) {
		this.uuid = user.uuid;
		this.username = user.username || '';
		this.password = user.password || '';
		this.name = user.name || '';
		this.email = user.email || '';
		this.pic = user.pic || '';
		this.role = user.roles || {};
		this.occupation = user.occupation || '';
		this.phone = user.phone || '';
		this.address = user.address;
		this.socialNetworks = user.socialNetworks;
	}
}
